export default {
  cities: state => state.cities,
  city: state => id => state.cities.filter(city => city.id == id)[0],
  // districts: state => state.districts,
  // district: state => state.district,
}